import React, { useState } from "react";
import { useAuth } from "../components/Contexts/AuthContext";
import { simulator } from "./simulator";

// Floating sandbox control. Tells the visitor the data is simulated and lets
// them trigger the events they would otherwise have to wait for.

const ACTIONS: { label: string; run: () => void }[] = [
  { label: "Send me a check reminder", run: () => simulator.demo("reminder") },
  { label: "Take one of my systems offline", run: () => simulator.demo("offline") },
  { label: "Bring an offline system back", run: () => simulator.demo("online") },
  { label: "Start a study on an idle system", run: () => simulator.demo("study") },
  { label: "Reset the sandbox", run: () => simulator.reset() },
];

const SandboxBar: React.FC = () => {
  const auth = useAuth();
  const [open, setOpen] = useState(false);
  if (!auth.isAuthenticated) return null;

  return (
    <div data-sandbox-bar style={{ position: "fixed", right: "16px", bottom: "88px", zIndex: 1040, display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "8px" }}>
      {open && (
        <div role="menu" style={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "14px", boxShadow: "0 12px 32px rgba(0,0,0,0.16)", padding: "8px", width: "260px" }}>
          <div style={{ padding: "6px 10px 8px", fontSize: "12px", color: "#64748b", lineHeight: 1.45 }}>
            Simulated systems and patients. Signed in as <strong style={{ color: "#0f172a" }}>{auth.user?.fullname}</strong>.
          </div>
          {ACTIONS.map((a) => (
            <button
              key={a.label}
              role="menuitem"
              onClick={() => {
                a.run();
                setOpen(false);
              }}
              style={{ display: "block", width: "100%", textAlign: "left", background: "none", border: "none", borderRadius: "8px", padding: "8px 10px", fontSize: "13px", color: "#1e293b", cursor: "pointer" }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
            >
              {a.label}
            </button>
          ))}
          <a href="https://epicarealert.com" style={{ display: "block", padding: "8px 10px", fontSize: "13px", color: "#2563eb", textDecoration: "none" }}>
            Back to epicarealert.com
          </a>
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        style={{ background: "#0f172a", color: "#ffffff", border: "none", borderRadius: "999px", padding: "9px 16px", fontSize: "13px", fontWeight: 600, cursor: "pointer", boxShadow: "0 8px 24px rgba(0,0,0,0.25)", display: "flex", alignItems: "center", gap: "8px" }}
      >
        <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#f59e0b" }} />
        Sandbox {open ? "▾" : "▴"}
      </button>
    </div>
  );
};

export default SandboxBar;
